import { FISCAL_YEAR_MIN_YEAR } from '../../constants/shared';
export const getDefaultCalculationsFilterFormModelState = () => ({
    calculationStatus: [],
    receiptStatus: [],
    statementStatus: [],
    statementType: [],
    year: {
        start: FISCAL_YEAR_MIN_YEAR,
        end: new Date().getFullYear()
    }
});
